import * as React from 'react';
import * as qs from 'qs';

import { FormGroup, Input, Label } from 'reactstrap';
import { changeQueryTerm, getQueryTerm } from '../../common/utils/search';

import { AppState } from 'common/models/AppState';
import { EntityActions } from 'common/entity/EntityActions';
import { Page } from 'common/components/layout/Page/Page';
import { RouteComponentProps } from 'react-router-dom';
import { Search } from 'common/components/Search';
import { TransactionsTable } from './TransactionsTable';

export interface TransactionsProps extends RouteComponentProps<{}> {
  appState: AppState;
  entityActions: EntityActions;
}
export interface TransactionsState {
  error?: string;
}

export class Transactions extends React.Component<TransactionsProps, TransactionsState> {
  state: TransactionsState = {};

  getQuery(props: TransactionsProps): string {
    const query = qs.parse(props.location.search.substring(1)).q;
    return query !== undefined ? query : '';
  }

  setQuery(query: string) {
    this.props.history.push(this.props.match.url + '?' + qs.stringify({ q: query }));
  }

  handleChangeDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setQuery(changeQueryTerm(this.getQuery(this.props), 'date', e.target.value));
  };

  handleSubmitSearch = (query: string) => {
    this.setQuery(query);
  };

  render() {
    const searchQuery = this.getQuery(this.props);
    const date = getQueryTerm(searchQuery, 'date');
    return (
      <Page title="Transactions">
        <div className="card card-responsive">
          <div className="p-3 p-sm-4">
            <div className="mb-3">
              {this.state.error && (
                <div className="alert alert-danger" style={{ marginTop: 20 }}>
                  {this.state.error}
                </div>
              )}
              <div>
                <FormGroup className="form-inline">
                  <Label style={{ marginRight: '1rem' }}>Date</Label>
                  <Input type="date" value={date ? date : ''} onChange={this.handleChangeDate} />
                </FormGroup>
                <div>
                  <Search
                    placeholder="Search by transaction id or date:YYYY-MM-DD"
                    onSubmit={this.handleSubmitSearch}
                    initialValue={searchQuery}
                    pathToClearSearch="/transactions"
                  />
                </div>
              </div>
              <div className="mt-3">
                <TransactionsTable
                  search={searchQuery}
                  appState={this.props.appState}
                  entityActions={this.props.entityActions}
                />
              </div>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Transactions/Transactions.tsx